import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {BetButtonView} from '@fantasmagames/slot/src/modules/keypad/bet/BetButtonView';
import {BetButtonModule} from '@fantasmagames/slot/src/modules/keypad/bet/BetButtonModule';
import {StopAutoplayButtonEvents} from '@fantasmagames/slot/src/modules/keypad/stopautoplaybutton/StopAutoplayButtonEvents';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {AutoPlayButtonModule} from '@fantasmagames/slot/src/modules/keypad/autoplay/AutoPlayButtonModule';

export class BetButtonWhileSpinningState extends ModuleState<BetButtonView, BetButtonModule> {
	public onEnterState(): void {
		this.module.hideBetButton();
	}

	public onLeaveState(): void {

	}

	protected setupEvents(): void {
		this.on(StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED, this.onStopAutoplayClicked);
		this.on(FlowModuleEvents.CAN_SPIN, this.onCanSpin);
	}

	protected onCanSpin(): void {
		this.module.gotoState(BetButtonModule.BASIC);
	}

	protected onStopAutoplayClicked(): void {
		this.module.autoPlayActive = false;
	}

}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/keypad/bet/states/BetButtonWhileSpinningState.ts